export class JobAlertListV2 {
  public pageSize: number = 5;
  public pageNumber: number = 1;
  public email: string = '';
  public companyCode: string = '';

}